import { removeOrphans } from '@/jsx/components/util';

export const getRenderingListeners = () => {
  return {
    beforeRenderRows: () => {
      removeOrphans();
    },
  };
};
